import angular from 'angular';

InspecAddEditDialogCtrl.$inject = ['$log', '$scope', 'dialogService', '$http', '$timeout'];

export default function InspecAddEditDialogCtrl($log, $scope, dialogService, $http, $timeout) {

    var inspectoresDelDistrito = [];
    var soloInspectoresDelDistrito = false;
    angular.forEach($scope.model.inspectores, function (inspector) {
        if ($scope.model.inspectoresDistrito.indexOf(inspector.id) > -1) {
            this.push(inspector);
            if (inspector.id == $scope.model.inspeccion.inspector_id)
                soloInspectoresDelDistrito = true;
        }
    }, inspectoresDelDistrito);

    $scope.inspectoresDelDistrito = inspectoresDelDistrito;
    $scope.soloInspectoresDelDistrito = soloInspectoresDelDistrito;

    $scope.noHayInspectoresPorDistrito = inspectoresDelDistrito.length < 1;

    $scope.mostrarTodosInspec = function () {
        $scope.soloInspectoresDelDistrito = !$scope.soloInspectoresDelDistrito;
    };

}